import styled from "styled-components";

const Image = styled.img`

`

export default Image